import * as React from 'react'
import 'intersection-observer'

export function useIsIntersecting(
  target: React.RefObject<HTMLElement> | React.MutableRefObject<Element | null>,
  options?: IntersectionObserverInit,
  shouldForceUpdate?: boolean,
): boolean {
  const [isIntersecting, setIsIntersecting] = React.useState<boolean>(false)

  React.useEffect(() => {
    if (target.current === null) {
      return
    }

    const observer = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (entry.target === target.current && entry.isIntersecting) {
          setIsIntersecting(true)
        } else {
          shouldForceUpdate && setIsIntersecting(false)
        }
      }
    }, options)
    observer.observe(target.current)

    return () => {
      if (target.current === null) {
        return
      }

      observer.unobserve(target.current)
    }
  }, [options])

  return isIntersecting
}
